import { Routes, Route, Navigate } from "react-router-dom";
import { User } from "./utils/helpers/types";
import NotFound from "./pages/not-found";
import "./styles/globals.scss";
import { RouteGuard, getDefaultLink } from "./utils/helpers/role-helpers";

import TaskCreation from "./pages/task-creation";
import TaskHistory from "./pages/task-history";
import AppConfig from "./pages/app-config";
import AllHistories from "./pages/history";
import Files from "./pages/files";

const getRoutes = (user: User | null) => {
  const defaultLink = getDefaultLink(user);

  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to={defaultLink} /> : <NotFound />}
      />
      <Route
        path="/spa/back-office-portlet"
        element={<Navigate to={defaultLink} />}
      />
      <Route path="*" element={<NotFound />} />

      <Route
        path="/task-creation"
        element={
          <RouteGuard currentUser={user} allowedUserTypes={["BO_ADMIN"]}>
            <TaskCreation />
          </RouteGuard>
        }
      />
      <Route
        path="/app-config"
        element={
          <RouteGuard currentUser={user} allowedUserTypes={["BO_ADMIN"]}>
            <AppConfig />
          </RouteGuard>
        }
      />
      <Route
        path="/task-history"
        element={
          <RouteGuard currentUser={user} allowedUserTypes={["BO_ADMIN"]}>
            <TaskHistory />
          </RouteGuard>
        }
      />
      <Route
        path="/history"
        element={
          <RouteGuard currentUser={user} allowedUserTypes={["BO_ADMIN"]}>
            <AllHistories />
          </RouteGuard>
        }
      />
      <Route
        path="/files"
        element={
          <RouteGuard currentUser={user} allowedUserTypes={["BO_ADMIN"]}>
            <Files />
          </RouteGuard>
        }
      />
    </Routes>
  );
};

export default getRoutes;
